<template>
  <vessel-table></vessel-table>
</template>

<script>
import VesselTable from '../components/tables/VesselTable.vue'

export default {
  name: 'Vessels',
  components: {
    VesselTable
  }
}
</script>

<style scoped></style>
